import config from '@/config'
import crypto from 'crypto'

export function symcrypt(text, key) {
  let iv = crypto.randomBytes(16)
  let bkey = Buffer.from(key, 'hex')
  let algo = 'aes256'
  let cipher = crypto.createCipheriv(algo, bkey, iv)
  let encrypted = cipher.update(text, 'utf8', 'hex')
  encrypted += cipher.final('hex')
  return { encrypted, iv }
}

export function symDecrypt(key, iv, encrypted) {
  let bkey = Buffer.from(key, 'hex')
  let biv = Buffer.from(iv, 'hex')
  let algo = 'aes256'
  let decipher = crypto.createDecipheriv(algo, bkey, biv)
  let decrypted = decipher.update(encrypted, 'hex', 'utf8');
  decrypted += decipher.final('utf8');
  return decrypted
}